import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash';
import { ORMMediator } from 'utility-ts-datasource';
import { IAppointmentType, IStudentService, IStudentServiceCategory } from '../types/appointment_interfaces';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';
import { IAppointmentReasonTypeDatasource } from './../datasources/appointment_reason_type_datasource';

interface IAppointmentsReasonQueryResult {
  typeList: IAppointmentType[];
  typeInstructions: string;
}

export class AppointmentsReasonQuery implements IQuery {
  private _result: IAppointmentsReasonQueryResult;

  constructor(
    private ngAppointmentReasonTypeDatasource: IAppointmentReasonTypeDatasource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource
  ) {
    ORMMediator.registerQuery(this, ngAppointmentReasonTypeDatasource, ngAppointmentReasonUsersource);
  }

  run(): this {
    const typeInstructions: string = _4.get(
      this.ngAppointmentReasonTypeDatasource.model,
      'appointment_type_instructions',
      ''
    );
    const typeList: IAppointmentType[] = _4.sortBy(this.ngAppointmentReasonTypeDatasource.values(), 'name');

    this._result = {
      typeList,
      typeInstructions
    };
    return this;
  }
  get result(): IAppointmentsReasonQueryResult {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/appointments_reason_query.ts